module.exports = __webpack_public_path__ + "img/1spade-06.75e85438.svg";